import Loading from '../../../Common/Loading';
import { Table } from './Table';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

const Tables = () => {
    const { isLoading, data } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Table type="asked" />
            <Table type="performed" />
            <Table type="principal-diagnosis" />
        </>
    );
};

export default Tables;
